import * as React from "react";
import { GLCheckbox } from "common/components";
import { useSelectedRows, useSelectedRowsDispatch } from "common/contexts";
import { Dir, File } from "../styledComponents";
import RuleInfoTooltip from "../RuleTooltip";
function RuleItem({ item, repoPath, setRepo, setRepoPath }) {
  const selectedRules = useSelectedRows();
  const selectedRulesDispatch = useSelectedRowsDispatch();
  const loadRepoRules = () => {
    setRepo(item);
    setRepoPath("");
  };
  const loadDirectory = () => setRepoPath(`${repoPath}/${item.name}`);
  const onSelect = (e) => {
    if (e.target.checked) {
      selectedRulesDispatch({ type: "add", payload: [item] });
    } else {
      selectedRulesDispatch({ type: "remove", payload: [item] });
    }
  };
  const isSelected = (rule) => !!selectedRules.find((sRule) => rule.id === sRule.id);
  if (!item.type) {
    return /* @__PURE__ */ React.createElement(Dir, { onClick: loadRepoRules, "data-testid": "repo" }, item.name);
  }
  if (item.type === "dir") {
    return /* @__PURE__ */ React.createElement(Dir, { title: item.name, onClick: loadDirectory, "data-testid": "directory" }, item.name, "/");
  }
  return /* @__PURE__ */ React.createElement(File, { htmlFor: `import-repo-file-${item.id}`, "data-testid": "file" }, /* @__PURE__ */ React.createElement(
    GLCheckbox,
    {
      id: `import-repo-file-${item.id}`,
      checked: isSelected(item),
      onChange: onSelect,
      "data-testid": "select-file"
    }
  ), /* @__PURE__ */ React.createElement(RuleInfoTooltip, { rule: item }), item.title);
}
export default RuleItem;
